export interface InquiryDto {
    seq: number,
    type: number,
    isMember: boolean,
    name: string,
    email: string,
    phone: string,
    isCompleted: boolean,
    reply: string,
    createdAt: string,
    content: string,
    checked?: boolean
}

export interface DetailInquiryDto {
    inquiryDto: InquiryDto,
    detailType: string,
    content: string
}

export const InitialDetailInquiryDto: DetailInquiryDto = {
    inquiryDto: {
        seq: 0,
        type: 0,
        isMember: false,
        name: "",
        email: "",
        phone: "",
        isCompleted: true,
        reply: "",
        createdAt: "",
        content: "",
    },
    detailType: "",
    content: ""
}